import client from './client';

// 계좌 등록
export const createAccount = async (data) => {
  const response = await client.post('/account', data);
  return response.data;
};

// 계좌 목록 조회
export const getAccounts = async () => {
  const response = await client.get('/account');
  return response.data;
};

// 계좌 삭제
export const deleteAccount = async (accountId) => {
  const response = await client.delete(`/account/${accountId}`);
  return response.data;
};

// 계좌 활성화/비활성화
export const toggleAccount = async (accountId) => {
  const response = await client.put(`/account/${accountId}/toggle`);
  return response.data;
};

// 계좌 잔고 조회
export const getBalance = async (accountId) => {
  const response = await client.get(`/account/${accountId}/balance`);
  return response.data;
};

// HTS ID 업데이트
export const updateHtsId = async (accountId, htsId) => {
  const response = await client.put(`/account/${accountId}/hts-id?hts_id=${encodeURIComponent(htsId)}`);
  return response.data;
};

// 포트폴리오 히스토리 조회
export const getPortfolioHistory = async (accountId, days = 30, startDate = null, endDate = null) => {
  let url = `/portfolio/history/${accountId}?days=${days}`;
  if (startDate && endDate) {
    url = `/portfolio/history/${accountId}?start_date=${startDate}&end_date=${endDate}`;
  }
  const response = await client.get(url);
  return response.data;
};

// 수동 스냅샷 생성
export const createSnapshot = async (accountId) => {
  const response = await client.post(`/portfolio/snapshot/${accountId}`);
  return response.data;
};

// 디스코드 웹훅 조회
export const getDiscordWebhook = async () => {
  const response = await client.get('/account/discord-webhook');
  return response.data;
};

// 디스코드 웹훅 설정
export const setDiscordWebhook = async (webhookUrl) => {
  const response = await client.post(`/account/discord-webhook?webhook_url=${encodeURIComponent(webhookUrl || '')}`);
  return response.data;
};

// 계좌 수정
export const updateAccount = async (accountId, data) => {
  const response = await client.put(`/account/${accountId}`, data);
  return response.data;
};

// 수동 청산 (시장가 매도)
export const manualSell = async (accountId, stockCode, quantity) => {
  const response = await client.post(`/account/${accountId}/sell`, null, {
    params: { stock_code: stockCode, quantity: quantity }
  });
  return response.data;
};

// 당일 주문 조회
export const getTodayOrders = async (accountId) => {
  const response = await client.get(`/account/${accountId}/today-orders`);
  return response.data;
};

// 거래 통계 조회
export const getTradeStats = async (accountId) => {
  const response = await client.get(`/account/${accountId}/trade-stats`);
  return response.data;
};

// 통계 시작일 저장
export const setStatsStartDate = async (accountId, date) => {
  const response = await client.put(`/account/${accountId}/stats-start-date`, { stats_start_date: date });
  return response.data;
};

// 통계 시작일 조회
export const getStatsStartDate = async (accountId) => {
  const response = await client.get(`/account/${accountId}/stats-start-date`);
  return response.data;
};

// 거래내역 조회 (청산 내역)
export const getTradeHistory = async (accountId, page = 1, limit = 20) => {
  const response = await client.get(`/account/${accountId}/trade-history?page=${page}&limit=${limit}`);
  return response.data;
};

// 보유종목 차트 데이터 조회
export const getHoldingsChart = async (accountId, days = 60, stockCodes = null) => {
  let url = `/account/${accountId}/holdings-chart?days=${days}`;
  if (stockCodes && stockCodes.length > 0) {
    url += `&stock_codes=${stockCodes.join(',')}`;
  }
  const response = await client.get(url);
  return response.data;
};

// 개별 종목 차트 데이터 조회
export const getStockChart = async (stockCode, days = 200) => {
  const response = await client.get(`/account/stock-chart/${stockCode}?days=${days}`);
  return response.data;
};
